var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJersey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.874C24.8366 32.874 32 25.7106 32 16.874C32 8.03747 24.8366 0.874023 16 0.874023C7.16344 0.874023 0 8.03747 0 16.874C0 25.7106 7.16344 32.874 16 32.874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6933 26.6159L18.9511 16.8738H18.951L28.6933 7.13145C28.2731 6.58545 27.8135 6.06014 27.3134 5.55995C26.8132 5.05983 26.288 4.60014 25.7419 4.18008L15.9997 13.9223L15.9997 13.9223L6.25747 4.18008C5.71153 4.6002 5.18616 5.05976 4.68597 5.55995C4.18578 6.06014 3.72616 6.58545 3.30609 7.13145L13.0483 16.8736L13.0483 16.8736L3.30603 26.616C3.72622 27.162 4.18584 27.6873 4.68591 28.1875C5.18609 28.6876 5.71134 29.1473 6.25741 29.5673L15.9997 19.8251L15.9997 19.8251L25.7419 29.5673C26.2878 29.1471 26.8132 28.6875 27.3134 28.1874C27.8136 27.6872 28.2732 27.1619 28.6933 26.6159V26.6159Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 5.74383L16.0004 6.43945L18.783 5.74383V3.37864L17.67 3.93514L16.0004 2.26558L14.3308 3.93514L13.2178 3.37864V5.74383Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2178 5.74351V7.48275C13.2178 9.61275 16.0004 10.2654 16.0004 10.2654C16.0004 10.2654 18.783 9.61269 18.783 7.48275V5.74351H13.2178Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/jersey.5c583036.svg";
export { ForwardRef as ReactComponent };